import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "flowchart-stairs-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.2 3.2a3.25 3.25 0 113.03 5.47v1.43c0 .69.56 1.25 1.25 1.25h9.04a2.75 2.75 0 012.75 2.75v1.24a3.25 3.25 0 11-1.5 0V14.1c0-.7-.56-1.25-1.25-1.25H7.48a2.75 2.75 0 01-2.75-2.75V8.66A3.25 3.25 0 013.2 3.2zm3.54 1.06a1.75 1.75 0 10-2.48 2.48 1.75 1.75 0 002.48-2.48zm13 13a1.75 1.75 0 10-2.48 2.48 1.75 1.75 0 002.48-2.48z"
    }, null, -1)
  ])))
}
export default { render: render }